import { request } from './api';
import { deviceParams } from './device';
import type { Coords, Connection, Ride } from './types';

// Alle Methoden sind `async`, auch wenn sie nur ein `request` zurueckgeben:
// `deviceParams()` laeuft synchron beim Zusammenbauen der Adresse, und ein
// synchroner Wurf liesse sich vom `.catch()` des Aufrufers nicht abfangen -
// er wuerde stattdessen die ganze Oberflaeche abreissen.
export const connections = {
  /** Erzeugt einen Einladungscode (24 h gültig, einmal verwendbar). */
  invite: async () =>
    request<{ code: string }>('/api/connections/invite', {
      method: 'POST',
      body: JSON.stringify(deviceParams()),
    }),

  /** Name des Einladenden, ohne den Code zu verbrauchen. */
  preview: async (code: string) =>
    request<{ inviterName: string }>(`/api/connections/preview/${encodeURIComponent(code.toUpperCase())}`),

  accept: async (code: string) =>
    request<{ connection: Connection }>(
      `/api/connections/accept/${encodeURIComponent(code.toUpperCase())}`,
      { method: 'POST', body: JSON.stringify(deviceParams()) },
    ),

  list: async () =>
    request<{ connections: Connection[] }>(`/api/connections?${new URLSearchParams(deviceParams()).toString()}`),

  rename: async (id: string, label: string) =>
    request<{ connection: Connection }>(`/api/connections/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ ...deviceParams(), label }),
    }),

  remove: async (id: string) =>
    request<{ ok: true }>(`/api/connections/${id}`, {
      method: 'DELETE',
      body: JSON.stringify(deviceParams()),
    }),

  subscribePush: async (subscription: PushSubscriptionJSON) =>
    request<{ ok: true }>('/api/devices/subscribe', {
      method: 'POST',
      body: JSON.stringify({ ...deviceParams(), subscription }),
    }),

  /** Der Kontakt-Kurzweg: Fahrt anlegen und dem Kontakt statt eines Codes direkt per Push schicken. */
  startRide: async (connectionId: string, origin: Coords, estimatedTime?: number | null) =>
    request<{ ride: Ride; token: string; pushed: boolean }>(
      `/api/connections/${connectionId}/start-ride`,
      { method: 'POST', body: JSON.stringify({ ...deviceParams(), origin, estimatedTime }) },
    ),
};
